function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
/*********************************************************************************
 GAME ACKNOWLEDGE

 

**********************************************************************************/
var GameAcknowledge = /*#__PURE__*/function () {
  function GameAcknowledge() {
    _classCallCheck(this, GameAcknowledge);
  }
  return _createClass(GameAcknowledge, [{
    key: "playerAcknowledgeNotice",
    value: function playerAcknowledgeNotice(msg, mycallback) {
      var _this = this;
      //
      // non-players (observers / pending joiners) have no controls to click --
      // auto-acknowledge after a short pause so the queue keeps moving
      //
      if (this.game.player == 0 && !Array.isArray(mycallback)) {
        this.halted = 1;
        setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                _context.n = 1;
                return mycallback();
              case 1:
                _this.halted = 0;
              case 2:
                return _context.a(2);
            }
          }, _callee);
        })), 1500);
        return 0;
      }
      var html = '';
      var options = null;
      if (Array.isArray(mycallback)) {
        options = mycallback;
      }
      if (options) {
        html = "<ul>";
        for (var z = 0; z < options.length; z++) {
          html += "<li class=\"option acknowledge\" id=\"".concat(z, "\">").concat(options[z].text, "</li>");
        }
        html += "</ul>";
      } else {
        html = "<ul><li class=\"option acknowledge\" id=\"confirmit\">".concat(this.acknowledge_text, "</li></ul>");
      }

      //
      // overlays, etc. may also have control display options
      // so we loop through anything that has ".controls" as its
      // class and update it to display the option.
      //
      document.querySelectorAll('.controls').forEach(function (el) {
        el.innerHTML = html;
      });
      if (document.getElementById('controls')) {
        document.getElementById('controls').innerHTML = html;
      }
      try {
        this.hud.hideBackButton();
        this.game.status = msg;
        this.hud.updateStatus(msg);
        this.hud.updateCards([]);
        this.lockInterface();
        var menu = [];
        if (options) {
          for (var _z = 0; _z < options.length; _z++) {
            menu.push({
              id: String(_z),
              label: options[_z].text,
              "class": 'acknowledge'
            });
          }
        } else {
          menu.push({
            id: 'confirmit',
            label: this.acknowledge_text,
            "class": 'acknowledge'
          });
        }
        var done = false;
        var finish = /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(id) {
            var idx;
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  if (!done) {
                    _context2.n = 1;
                    break;
                  }
                  return _context2.a(2);
                case 1:
                  done = true;
                  _this.unlockInterface();
                  _this.game.status = 'acknowledged';
                  _this.hud.updateStatus('acknowledged');
                  _this.clearShotClock();
                  _this.hud.updateMenu([]);
                  document.querySelectorAll('.acknowledge').forEach(function (el) {
                    el.onclick = null;
                  });
                  if (!options) {
                    _context2.n = 3;
                    break;
                  }
                  idx = parseInt(id);
                  _context2.n = 2;
                  return options[idx].mycallback();
                case 2:
                  _context2.n = 4;
                  break;
                case 3:
                  _context2.n = 4;
                  return mycallback();
                case 4:
                  _this.halted = 0;
                case 5:
                  return _context2.a(2);
              }
            }, _callee2);
          }));
          return function finish(_x) {
            return _ref2.apply(this, arguments);
          };
        }();
        this.hud.updateMenu(menu, /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(id) {
            return _regenerator().w(function (_context3) {
              while (1) switch (_context3.n) {
                case 0:
                  _context3.n = 1;
                  return finish(id);
                case 1:
                  return _context3.a(2);
              }
            }, _callee3);
          }));
          return function (_x2) {
            return _ref3.apply(this, arguments);
          };
        }());
        this.cardbox.attachCardEvents();
        document.querySelectorAll('.acknowledge').forEach(function (el) {
          el.onclick = /*#__PURE__*/function () {
            var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(e) {
              return _regenerator().w(function (_context4) {
                while (1) switch (_context4.n) {
                  case 0:
                    e.stopPropagation();
                    _context4.n = 1;
                    return finish(e.currentTarget.id);
                  case 1:
                    return _context4.a(2);
                }
              }, _callee4);
            }));
            return function (_x3) {
              return _ref4.apply(this, arguments);
            };
          }();
        });
        this.playChime();
        this.ignore_notifications = false;
      } catch (err) {
        console.error('GT: Error with ACKWNOLEDGE notice!: ' + err);
      }
      console.info('GT: Halt game for acknowledge');

      // this should be ok
      this.halted = 1;

      // pls do not re-enable without thinking very, very carefully
      //this.saveGame(this.game.id);

      return 0;
    }
  }, {
    key: "addPublickeyConfirm",
    value: function addPublickeyConfirm(pubkey, confs) {
      this.game.tmp_confirms_received += parseInt(confs);
      this.game.tmp_confirms_players.push(pubkey);
    }
  }, {
    key: "hasPlayerConfirmed",
    value: function hasPlayerConfirmed(pubkey) {
      if (this.game.tmp_confirms_players.includes(pubkey)) {
        return 1;
      }
      if (this.game.confirms_players.includes(pubkey)) {
        return 1;
      }
      return 0;
    }
  }, {
    key: "isGameHalted",
    value: function isGameHalted() {
      for (var z = this.game.queue.length - 1; z >= 0; z--) {
        var gle = this.game.queue[z].split('\t');
        if (gle[0] === 'HALTED') {
          return 1;
        }
      }
      return 0;
    }
  }, {
    key: "areMoreConfirmsNeeded",
    value: function areMoreConfirmsNeeded() {
      if (this.game.confirms_received < this.game.confirms_needed.length) {
        return 1;
      }
      return 0;
    }
  }, {
    key: "removeConfirmsNeeded",
    value: function removeConfirmsNeeded(array_of_player_nums) {
      this.game.confirms_needed = [];
      this.game.confirms_received = 0;
      this.game.confirms_players = [];
      this.game.tmp_confirms_received = 0;
      this.game.tmp_confirms_players = [];
      for (var i = 0; i < this.game.players.length; i++) {
        this.game.confirms_needed[i] = 0;
      }
    }
  }, {
    key: "resetConfirmsNeeded",
    value: function resetConfirmsNeeded(array_of_player_nums) {
      this.game.confirms_needed = [];
      this.game.confirms_received = 0;
      this.game.confirms_players = [];
      this.game.tmp_confirm_sent = 0;
      this.game.tmp_confirms_received = 0;
      this.game.tmp_confirms_players = [];
      var type_of_indicator = 1; // numb

      if (array_of_player_nums.length > 0) {
        if (array_of_player_nums[0].length > 10) {
          type_of_indicator = 2;
        }
      }
      if (type_of_indicator == 1) {
        for (var i = 0; i < array_of_player_nums.length; i++) {
          array_of_player_nums[i] = parseInt(array_of_player_nums[i]);
        }
      }
      console.debug('RESETCONFIRMSNEEDED in');
      console.debug('type of indicator: ' + type_of_indicator);
      console.debug('array of player nums: ' + JSON.stringify(array_of_player_nums));
      for (var _i = 0; _i < this.game.players.length; _i++) {
        if (type_of_indicator == 1) {
          if (array_of_player_nums.includes(_i + 1)) {
            this.game.confirms_needed[_i] = 1;
          } else {
            this.game.confirms_needed[_i] = 0;
          }
        } else {
          console.debug('checking: ' + this.game.players[_i]);
          if (array_of_player_nums.includes(this.game.players[_i])) {
            console.debug('confirm needed!');
            this.game.confirms_needed[_i] = 1;
          } else {
            console.debug('confirm not needed!');
            this.game.confirms_needed[_i] = 0;
          }
        }
      }
    }
  }]);
}();
module.exports = GameAcknowledge;